import React, { useEffect, useState } from "react";
import Tooltip from "bootstrap/js/dist/tooltip";


import { Carousel } from 'react-bootstrap'; 
import ProductExtraDetails from "./ProductExtraDetails";
import PortfolioFAQViewer from "./PortfolioFAQViewer";
import { getPortfolioFAQPdf } from "../../api/PortfolioFAQApi";

const ProductDetail = ({ data }) => {

  const [showPdf, setShowPdf] =useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [loadingPdf, setLoadingPdf] = useState(false);

  useEffect(() => {
    // Initialize Bootstrap tooltips
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.map((el) => new Tooltip(el));
  }, []);


  const {
    productCode,
    productName,
    ingredients,
    overview,
    assay,
    coNutrients,
    functionalUse,
    studies,
    benefits,
    bannerImage = [],
    certificates = [],
  } = data;

  /**
   * Helper function to determine the appropriate Bootstrap column class.
   * If the content is long (over 200 chars), use full width (col-12).
   * Otherwise, use half width (col-md-6) for a two-column layout.
   */
  const getColumnClass = (value) => {
    // Treat null/undefined/empty string as short (or just don't render them via conditional rendering)
    if (!value) return 'col-md-6'; 

    // Adjust the threshold (e.g., 200 characters) based on your typical data
    const LENGTH_THRESHOLD = 200; 

    return value.length > LENGTH_THRESHOLD ? 'col-12' : 'col-md-6';
  };


  const handleImageRetry = (e, maxRetries = 2) => {
    const currentRetry = parseInt(e.target.dataset.retry || "0", 10);

    if (currentRetry < maxRetries) {
      e.target.dataset.retry = currentRetry + 1;

      // Force re-fetch (cache-busting)
      const originalSrc = e.target.src.split("?")[0];
      e.target.src = `${originalSrc}?retry=${Date.now()}`;
    } else {
      // After 2 failed retries → fallback image
      e.target.onerror = null;
      e.target.src =
        "https://via.placeholder.com/755x489/90c695/ffffff?text=Product+Image";
    }
  };

        const iconMap = {
      "💊︎": "/images/Portfolio/Icons/capsule.png",
      "🍚︎": "/images/Portfolio/Icons/foods.png",
      "🥛︎": "/images/Portfolio/Icons/beverages.png",
      "🚰︎": "/images/Portfolio/Icons/ors.png",
      "⊘": "/images/Portfolio/Icons/tablet.png",
      "🍞︎": "/images/Portfolio/Icons/baking.png",
      "🧂︎": "/images/Portfolio/Icons/Seasoning.png",
      "🍨︎": "/images/Portfolio/Icons/ice-cream.png",
      "🥄︎": "/images/Portfolio/Icons/powder.png",

    };

const handleEnquiry = async () => {

  try {

    setLoadingPdf(true);

    // Get signed URL from backend

    const response =
      await getPortfolioFAQPdf(
        productCode
      );

    const signedUrl =
      response.data.url;

    // Fetch PDF

    const pdfResponse =
      await fetch(signedUrl);

    if (!pdfResponse.ok) {

      throw new Error(
        "Failed to fetch PDF"
      );
    }

    // Convert PDF to Blob

    const pdfBlob =
      await pdfResponse.blob();

    // Create browser URL

    const blobUrl =
      URL.createObjectURL(
        pdfBlob
      );

    // Open modal

    setPdfUrl(blobUrl);

    setShowPdf(true);

  } catch (error) {

    console.error(
      "FAQ PDF Error:",
      error
    );

    alert(
      "Unable to load FAQ PDF"
    );

  } finally {

    setLoadingPdf(false);
  }
};

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        minHeight: "100vh",
      }}
    >
      <style>
        {`
          .banner-wrapper {
            position: relative;
            width: 100%;
            overflow: hidden;
            border-radius: 12px;
            background-color: #fff;
          }

          .banner-image {
            width: 100%;
            object-fit: contain;
            object-position: center;
            display: block;
          }
          
          .tooltip-inner {
            background-color: #f8f2f2ff !important;
            color: #0d0e0dff !important;
            border: 1px solid #ccc;
            font-size: 0.9rem;
            padding: 6px 10px;
            border-radius: 6px;
          }
        `}
      </style>

      <div className="container py-5">
        {/* Header */}
        <div className="text-center mb-5">
          <h1
            className="fw-bold mb-2"
            style={{ fontSize: "2.5rem", color: "#2c3e50" }}
          >
            {productName}
          </h1>
        </div>

        <div className="row align-items-start g-4">
          {/* LEFT SIDE (No changes) */}
          <div className="col-lg-5">
            <div className="bg-white rounded-4 shadow-lg p-4 h-100 text-start">
              {/* Product Code */}
              <div className="p-3 bg-light rounded-3 w-100 mb-3">
                <strong className="d-block mb-1">Product Code</strong>
                <span className="fs-5">{productCode}</span>
              </div>

              {bannerImage && bannerImage.length > 0 ? (
                <Carousel 
                  interval={3000} 
                  indicators={false} 
                  className="mb-3 rounded shadow" 
                >
                  {bannerImage.map((img, index) => (
                    <Carousel.Item key={index}> 
                      <div className="banner-wrapper">
                        <img
                          src={`${process.env.PUBLIC_URL}/${img}`}
                          alt={`${productName} ${index + 1}`}
                          className="d-block banner-image"
                          loading="lazy"
                          data-retry="0"
                          onError={(e) => handleImageRetry(e)}
                        />
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              ) : (
               <div className="banner-wrapper mb-3">
                  <img
                    src="https://via.placeholder.com/755x489/90c695/ffffff?text=Product+Image"
                    alt={productName}
                    className="d-block banner-image"
                  />
                </div>
              )}

              {/* Product Overview */}
              <div className="p-3 bg-light rounded-3 w-100 mb-4">
                <strong className="d-block mb-1">Overview</strong>
                <span>{overview}</span>
              </div>

              {/* Certificate Logos */}
              {certificates.length > 0 && (
                <div className="d-flex justify-content-center align-items-center flex-wrap gap-4 mb-4 text-center">
                  {certificates.map((src, i) => (
                    <img
                      key={i}
                      src={`${process.env.PUBLIC_URL}/${src}`}
                      alt={`Certificate ${i + 1}`}
                      className="img-fluid mx-2"
                      style={{ height: "50px", objectFit: "contain" }}
                      loading="lazy"
                      data-retry="0"
                      onError={(e) => handleImageRetry(e, 1)}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* RIGHT SIDE (Dynamic Layout Applied) */}
          <div className="col-lg-7">
            <div className="bg-white rounded-4 shadow-lg p-4 h-100">
              <h4 className="text-primary mb-4 border-bottom pb-3">
                Product Information
              </h4>
              <div className="row g-2">
                
                {/* Product Name (Always col-12) */}
                <div className="col-12">
                  <div className="p-3 bg-light rounded-3">
                    <strong className="d-block mb-1">Product Name</strong>
                    <span className="fs-5">{productName}</span>
                  </div>
                </div>

                {/* Ingredients: Dynamic Column */}
                {ingredients && (
                  <div className={getColumnClass(ingredients)}>
                    <div className="p-3 bg-light rounded-3">
                      <strong className="d-block mb-1">Ingredients</strong>
                      <span>{ingredients}</span>
                    </div>
                  </div>
                )}

                {/* Assay: Dynamic Column */}
                {assay && (
                  <div className={getColumnClass(assay)}>
                    <div className="p-3 bg-light rounded-3">
                      <strong className="d-block mb-1">Assay</strong>
                      <span >{assay}</span>
                    </div>
                  </div>
                )}

                {/* Co-nutrients: Dynamic Column */}
                {coNutrients && (
                  <div className={getColumnClass(coNutrients)}>
                    <div className="p-3 bg-light rounded-3">
                      <strong className="d-block mb-1">Co-nutrients</strong>
                      <span>{coNutrients}</span>
                    </div>
                  </div>
                )}
                
                {/* Studies: Dynamic Column */}
                {studies && (
                  <div className={getColumnClass(studies)}>
                    <div className="p-3 bg-light rounded-3">
                      <strong className="d-block mb-1">Studies</strong>
                      <span>{studies}</span>
                    </div>
                  </div>
                )}

                {/* Benefits: Dynamic Column */}
                {benefits && (
                  <div className={getColumnClass(benefits)}>
                    <div className="p-3 bg-light rounded-3">
                      <strong className="d-block mb-1">Benefits</strong>
                      <span>{benefits}</span>
                    </div>
                  </div>
                )}


                {/* Functional Use (Always col-12 for space and icons) */}
                <div className="col-12">
                  <div
                    className="p-3 bg-light rounded-3"
                    style={{ position: "relative" }}
                  >
                    <div className="d-flex align-items-center flex-wrap mb-2">
                      <strong>Functional Use</strong>
                      {functionalUse.note && (
                        <small className="ms-3 fst-italic">
                          {functionalUse.note}
                        </small>
                      )}
                    </div>

                      <div style={{ 
                        display: "flex", 
                        flexWrap: "wrap", 
                        gap: "12px", 
                        alignItems: "center" 
                      }}>    
                        {functionalUse.main.split(",").map((item, index) => {
                        const trimmed = item.trim();
                        const [emoji, ...textArr] = trimmed.split(" ");
                        const tooltipText = textArr.join(" ");

                        return (
                          <span
                            key={index}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={tooltipText}
                            className="me-3"
                            style={{
                              cursor: "pointer",
                              fontSize: "1.4rem",
                              transition: "transform 0.2s ease",
                              filter: "grayscale(100%)",
                             
                            }}
                          onMouseEnter={(e) =>{
                            const img = e.currentTarget.querySelector("img");
                            img.style.transform = "scale(1.2)";
                            img.style.filter = "grayscale(0%)";
                          }}
                          onMouseLeave={(e) =>{
                            const img = e.currentTarget.querySelector("img");
                            img.style.transform = "scale(1)";
                            img.style.filter = "grayscale(100%)";
                          }}
                          >
                          <img
                            src={iconMap[emoji] || "/images/Portfolio/Icons/default.png"}
                            alt={tooltipText}
                            style={{
                              width: "22px",
                              height: "22px",
                              objectFit: "contain",
                              filter: "grayscale(100%)",
                              transition: "transform 0.2s ease"
                            }}
                          />
                          </span>
                        );
                      })}
                    </div>
                  </div>
                </div>

                {/* Bottom Links (Always col-12) */}
                <div className="col-12">
                  <div className="p-3 px-4 bg-light rounded-3 d-flex">
                      {/* <button
                        type="button"
                        className="btn btn-link text-decoration-none fw-semibold text-primary me-auto p-0 border-0"
                        onClick={handleEnquiry}
                        disabled={loadingPdf}
                        style={{
                          boxShadow: "none"
                        }}
                      >
                        {loadingPdf
                          ? "Loading..."
                          : "❓ FAQs"}
                      </button> */}
                  
                      
                       {["SBOVZ-B12-TCBL"].includes(productCode) && (
                    <a
                      href="#"
                      className="text-decoration-none fw-semibold text-primary mx-auto"
                    >
                      🌿 Sustainability Story
                    </a>
                       )}
                   <button
                      type="button"
                      className="btn btn-link text-decoration-none fw-semibold text-primary ms-auto p-0 border-0"
                      style={{
                        boxShadow: "none"
                      }}
                    >
                      📩 Enquiry
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End RIGHT SIDE */}
        </div>
        {/* <ProductExtraDetails productCode={productCode} /> */}

        {/* <PortfolioFAQViewer
            show={showPdf}
            onHide={() => setShowPdf(false)}
            pdfUrl={pdfUrl}
          /> */}

      </div>
    </div>
  );
};

export default ProductDetail;